module.exports = __webpack_public_path__ + "static/forecast/weather/daysnowshowers-6af3545c580b0207a0c8188ec1564d3b.svg";